import { render, staticRenderFns } from "./ProviderEmployees.vue?vue&type=template&id=c1732cba&scoped=true&"
import script from "./ProviderEmployees.vue?vue&type=script&lang=js&"
export * from "./ProviderEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ProviderEmployees.vue?vue&type=style&index=0&id=c1732cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1732cba",
  null
  
)

export default component.exports